import { Globe, ChevronDown, Users, BarChart3, ShieldCheck } from "lucide-react";
import logo from "../assets/jamora-logo.png";
import pharmacyPhoto from "../assets/auth-pharmacy.png";

const FEATURES = [
  { icon: Users, label: "Suivi des\nprospects" },
  { icon: BarChart3, label: "Productivité\naccrue" },
  { icon: ShieldCheck, label: "Une croissance\ndurable" },
];

function BrandLockup() {
  return (
    <div className="flex items-center gap-3">
      <img src={logo} alt="" className="h-10 w-10 flex-shrink-0" />
      <div>
        <div className="font-serif-display text-2xl font-bold text-jamora leading-none">Jamora</div>
        <div className="text-2xs font-semibold tracking-[0.25em] text-slate-500 mt-0.5">CRM</div>
      </div>
    </div>
  );
}

function LanguageBadge() {
  return (
    <div
      role="note"
      aria-label="Langue : Français"
      className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white/80 px-3 py-1.5 text-xs font-medium text-slate-600 shadow-sm"
    >
      <Globe size={14} />
      FR
      <ChevronDown size={12} className="text-slate-400" />
    </div>
  );
}

export default function AuthLayout({ kicker, headlineLines, quote, children }) {
  return (
    <div className="min-h-screen flex bg-white">
      <div className="relative hidden lg:flex lg:w-[45%] xl:w-[42%] overflow-hidden flex-shrink-0">
        <img
          src={pharmacyPhoto}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          style={{ objectPosition: "18% 40%" }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(100deg, rgba(248,250,252,0.55) 0%, rgba(248,250,252,0.05) 30%, rgba(248,250,252,0) 55%)",
          }}
        />
        <div className="absolute inset-0 bg-background" style={{ clipPath: "url(#auth-wave-clip)" }} />
        <svg width="0" height="0" className="absolute">
          <defs>
            <clipPath id="auth-wave-clip" clipPathUnits="objectBoundingBox">
              <path d="M0,0 H0.68 C0.85,0.14 0.58,0.3 0.75,0.48 C0.58,0.68 0.85,0.85 0.68,1 H0 Z" />
            </clipPath>
          </defs>
        </svg>

        <div className="relative z-10 flex h-full w-full flex-col justify-between px-10 py-10 xl:px-14 xl:py-12 max-w-[560px]">
          <div className="space-y-8">
            <BrandLockup />

            <div className="space-y-4">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500 max-w-[360px]">
                  {kicker}
                </p>
                <div className="mt-3 h-0.5 w-8 bg-jamora" />
              </div>
              <h1 className="font-serif-display text-[34px] xl:text-[38px] font-bold leading-[1.15] text-slate-900">
                {headlineLines[0]}
                <br />
                <span className="text-jamora">{headlineLines[1]}</span>
              </h1>
              <p className="text-sm text-slate-600 leading-relaxed max-w-[380px]">
                Jamora CRM vous aide à centraliser vos prospects, suivre vos opportunités et
                développer votre réseau de pharmacies en toute simplicité.
              </p>
            </div>

            <div className="flex gap-6">
              {FEATURES.map(({ icon: Icon, label }) => (
                <div key={label} className="flex flex-col items-center text-center gap-2 w-20">
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-jamora-50">
                    <Icon size={20} className="text-jamora" />
                  </div>
                  <span className="text-xs text-slate-600 whitespace-pre-line leading-tight">{label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-6">
            <div className="border-l-2 pl-4 border-jamora">
              <p className="font-serif-display italic text-lg text-slate-700 leading-snug">“{quote}”</p>
            </div>
            <p className="text-xs text-slate-400">© {new Date().getFullYear()} Jamora. Tous droits réservés.</p>
          </div>
        </div>
      </div>

      <div className="relative flex flex-1 flex-col bg-white">
        <div className="flex items-center justify-between px-6 py-6 lg:justify-end">
          <div className="lg:hidden">
            <BrandLockup />
          </div>
          <LanguageBadge />
        </div>
        <div className="flex flex-1 items-center justify-center px-6 pb-16">
          <div className="w-full max-w-[420px]">{children}</div>
        </div>
      </div>
    </div>
  );
}
